import { render, staticRenderFns } from "./SmsAndAppPushTemp.vue?vue&type=template&id=6559a006&scoped=true"
import script from "./SmsAndAppPushTemp.vue?vue&type=script&lang=js"
export * from "./SmsAndAppPushTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559a006",
  null
  
)

export default component.exports